import React from 'react'

export const InputCompo = ({ type, defaultValue, name, placeholder, disabled, required, value, onChange, className, onClick, checked, readOnly, onKeyDown }) => {
    return (
        <>
            <input onKeyDown={onKeyDown} defaultValue={defaultValue} disabled={disabled} required={required} readOnly={readOnly} checked={checked} onClick={onClick && onClick} onChange={onChange && onChange} type={type} value={value} name={name} placeholder={placeholder} className={className} />
        </>
    )
}
